import { useEffect } from 'react';

export function useSourceCodePersistence() {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const currentUrl = new URL(window.location.href);
      const currentParams = currentUrl.searchParams;

      const referrer = document.referrer;
      let referrerSource = null;

      if (referrer) {
        try {
          const refUrl = new URL(referrer);
          referrerSource = refUrl.searchParams.get('source_code');
        } catch (e) {
          // ignore invalid referrer URLs
        }
      }

      const sourceFromUrl = currentParams.get('source_code');
      const sourceFromStorage = localStorage.getItem('source_code');

      // Decide which source code to use
      const finalSourceCode =
        referrerSource || sourceFromUrl || sourceFromStorage;

      if (finalSourceCode && finalSourceCode !== 'IDAAA') {
        // Save to localStorage
        localStorage.setItem('source_code', finalSourceCode);

        // Update current URL if missing
        if (!sourceFromUrl || sourceFromUrl !== finalSourceCode) {
          currentParams.set('source_code', finalSourceCode);
          window.history.replaceState(
            {},
            '',
            `${currentUrl.pathname}?${currentParams.toString()}${
              currentUrl.hash
            }`
          );
        }
      }
      const handleBeforeUnload = () => {
        localStorage.removeItem('source_code');
      };

      window.addEventListener('beforeunload', handleBeforeUnload);

      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      };
    }
  }, []);
}
